import React from 'react';
import { APITypes } from '../../../../../primary-record-types';
import _isEqual from 'lodash/isEqual';
import AttachmentListItem, {
    NoteFileFileProps,
    NoteImageFileProps,
    TempFileFileProps,
    TempImageFileProps,
} from '../../AttachmentListItem';
import Stack, { contentStackSpacing } from '../../../../v2BaseComponents/Stack';

const isCreate = (item: APITypes.notesService.NoteFileUpdate): item is APITypes.notesService.NoteFileCreate => {
    return (item as APITypes.notesService.NoteFileCreate)?.type === 'create';
};

export type AttachmentListOwnProps = {
    images: APITypes.notesService.NoteFileUpdate[];
    onUpdateImages: (images: APITypes.notesService.NoteFileUpdate[]) => void;
    files: APITypes.notesService.NoteFileUpdate[];
    onUpdateFiles: (file: APITypes.notesService.NoteFileUpdate[]) => void;
    isDisabled: boolean;
    noteId?: string;
};

export type AttachmentListProps = AttachmentListOwnProps;

const AttachmentList: React.FC<AttachmentListProps> = (props) => {
    const renderSection = (items: APITypes.notesService.NoteFileUpdate[], type: 'file' | 'image') => {
        if (items.length === 0) return null;

        const renderContainer = (children: React.ReactNode) => (
            <Stack vertical fullWidth space={contentStackSpacing}>
                {children}
            </Stack>
        );

        if (type === 'file') {
            return renderContainer(
                items.map((item) => {
                    const fileProps: TempFileFileProps | NoteFileFileProps = isCreate(item)
                        ? {
                              type: 'temp-file',
                              tempFileId: item.tempFileId,
                          }
                        : {
                              type: 'file',
                              fileId: item.fileId,
                              noteId: props.noteId!,
                          };
                    return (
                        <AttachmentListItem
                            key={JSON.stringify(fileProps)}
                            file={fileProps}
                            onDelete={() => {
                                const newValue = props.files.filter((i) => !_isEqual(i, item));
                                props.onUpdateFiles(newValue);
                            }}
                            description={item.description}
                            medicalProfileFile={null}
                            icon={item.type === 'create' && item.contentType === 'audio/webm' ? 'Mic' : undefined}
                        />
                    );
                }),
            );
        } else {
            return renderContainer(
                items.map((item) => {
                    const imageProps: TempImageFileProps | NoteImageFileProps = isCreate(item)
                        ? {
                              type: 'temp-image',
                              tempFileId: item.tempFileId,
                          }
                        : {
                              type: 'image',
                              fileId: item.fileId,
                              noteId: props.noteId!,
                          };
                    return (
                        <AttachmentListItem
                            key={JSON.stringify(imageProps)}
                            file={imageProps}
                            onDelete={() => {
                                const newValue = props.images.filter((i) => !_isEqual(i, item));
                                props.onUpdateImages(newValue);
                            }}
                            description={item.description}
                            medicalProfileFile={null}
                        />
                    );
                }),
            );
        }
    };

    return (
        <Stack vertical fullWidth space={contentStackSpacing}>
            {renderSection(props.images, 'image')}
            {renderSection(props.files, 'file')}
        </Stack>
    );
};

export default React.memo(AttachmentList);
